module.exports = __webpack_public_path__ + "img/gh.4adfff2c.jpg";